// Stable enum — represents diagnostic question responses (Oui/Non/SansObjet)
// DO NOT generate from CSV — this is a semantic constant
export enum DiagnosticReponse {
  Oui = 'Oui',
  Non = 'Non',
  SansObjet = 'SansObjet',
}
